import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useApp } from '../../contexts/AppContext';
import LoadingSpinner from '../common/LoadingSpinner';

const AuthLayout: React.FC = () => {
  const { state } = useApp();
  const location = useLocation();
  const currentPath = location.pathname;

  if (state.loading) {
    return <LoadingSpinner fullScreen tip="正在加载..." />;
  }

  // 如果未认证，允许访问登录页面和邮箱验证页面
  if (!state.isAuthenticated || !state.user) {
    if (currentPath !== '/auth/login' && currentPath !== '/auth/verify-email') {
      return <Navigate to="/auth/login" replace />;
    }
    return (
      <div className="auth-container">
        <Outlet />
      </div>
    );
  }

  // 如果已认证，根据用户状态和当前路径决定行为
  if (state.isAuthenticated && state.user) {
    // 如果密码未初始化
    if (!state.user.is_initialized) {
      if (currentPath !== '/auth/initialize-password') {
        return <Navigate to="/auth/initialize-password" replace />;
      }
      // 当前就在初始化密码页面，允许渲染
      return (
        <div className="auth-container">
          <Outlet />
        </div>
      );
    }
    
    // 如果OTP已启用但未验证
    if (state.user.otp_enabled && !state.user.otp_verified) {
      if (currentPath !== '/auth/verify-otp') {
        return <Navigate to="/auth/verify-otp" replace />;
      }
      // 当前就在OTP验证页面，允许渲染
      return (
        <div className="auth-container">
          <Outlet />
        </div>
      );
    }
    
    // 如果用户已完全认证，允许访问邮箱验证页面，其他认证页面重定向到dashboard
    if (currentPath === '/auth/verify-email') {
      return (
        <div className="auth-container">
          <Outlet />
        </div>
      );
    }
    
    // 其他认证页面重定向到dashboard
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="auth-container">
      <Outlet />
    </div>
  );
};

export default AuthLayout;